import type { FragmentOf } from "@opensea/graphql"
import { readFragment } from "@opensea/graphql"
import { itemQuantitiesForQuoteFragment } from "./itemQuantitiesForQuote.fragment"

export const itemQuantitiesForQuote = (
  quoteKey: FragmentOf<typeof itemQuantitiesForQuoteFragment>,
) => {
  const quote = readFragment(itemQuantitiesForQuoteFragment, quoteKey)
  return quote.itemQuotes.map(itemQuote => ({
    item: {
      tokenId: itemQuote.item.tokenId,
      contractAddress: itemQuote.item.contractAddress,
      chain: itemQuote.item.chain.identifier,
    },
    quantity: itemQuote.__typename === "ItemQuote" ? itemQuote.quantity : 1,
    pricePerItem:
      itemQuote.__typename === "ItemQuote"
        ? {
            unit: itemQuote.pricePerItem.token.unit.toString(),
            contractAddress: itemQuote.pricePerItem.token.address,
          }
        : undefined,
    orderId:
      itemQuote.__typename === "ItemQuote" ? itemQuote.orderId : undefined,
  }))
}
